import { HeartHandshake, ShieldCheck, Waypoints } from "lucide-react";
import MotionSection from "../common/MotionSection";

const trustItems = [
  {
    title: "Personalized Guidance",
    description: "Every student receives advice shaped around profile, goals, and long-term plans.",
    icon: HeartHandshake
  },
  {
    title: "Transparent Process",
    description: "Families stay informed through structured updates and clear expectations.",
    icon: ShieldCheck
  },
  {
    title: "End-to-End Support",
    description: "From shortlisting to documentation and visa guidance, the journey stays organized.",
    icon: Waypoints
  }
];

function TestimonialsTrustSection() {
  return (
    <MotionSection className="py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-6">
        <div className="rounded-[2rem] border border-midnight-navy/10 bg-white/90 p-6 shadow-soft md:p-10">
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-royal-blue">Why It Matters</p>
          <h2 className="mt-4 text-2xl sm:text-3xl md:text-5xl">Trusted Guidance Behind Every Story</h2>
          <p className="mt-4 max-w-3xl text-sm leading-relaxed text-slate-text/82 sm:text-base md:text-lg">
            These testimonials reflect a consistent experience: clear planning, honest communication, and dependable
            support for students and families.
          </p>

          <div className="mt-8 grid gap-4 md:grid-cols-3">
            {trustItems.map((item) => {
              const Icon = item.icon;
              return (
                <article key={item.title} className="rounded-2xl bg-sky-glow/70 p-5">
                  <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-white text-royal-blue">
                    <Icon className="h-5 w-5" aria-hidden="true" />
                  </span>
                  <h3 className="mt-4 text-xl leading-tight">{item.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-text/82">{item.description}</p>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </MotionSection>
  );
}

export default TestimonialsTrustSection;
